import {FC, Suspense, useEffect} from 'react';

import {componentItems} from 'app/componentItems';
import {ErrorBoundary} from 'app/core/errorHandler/errorBoundary';
import {ComponentPortal} from 'app/utils/initialize/components/componentPortal';
import {GemInitializeComponentsProps} from 'app/utils/initialize/interface';
import {useComponentMountDataItems} from 'app/utils/initialize/useComponentMountDataItems';

export const GemInitializeComponents: FC<GemInitializeComponentsProps> = ({context = document.body, onMountedCallback}) => {
    const componentMountDataItems = useComponentMountDataItems(context, componentItems);

    useEffect(() => {
        onMountedCallback?.();
    }, [onMountedCallback]);

    return componentMountDataItems.map((item) => {
        return (
            <ErrorBoundary msg="" key={item.key}>
                <ComponentPortal element={item.element} removeContent={item.removePortalContent}>
                    <Suspense>
                        <item.ReactLazyComponent config={item.config} element={item.element} />
                    </Suspense>
                </ComponentPortal>
            </ErrorBoundary>
        );
    });
};
